export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

export function formatDate(value: string | Date | null | undefined, opts: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }) {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  return Number.isNaN(d.getTime()) ? '—' : new Intl.DateTimeFormat(undefined, opts).format(d);
}

export function formatDateTime(value: string | Date | null | undefined) {
  return formatDate(value, { dateStyle: 'medium', timeStyle: 'short' });
}

export function relativeTime(value: string | Date | null | undefined): string {
  if (!value) return '';
  const d = typeof value === 'string' ? new Date(value) : value;
  const diff = (d.getTime() - Date.now()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
  const abs = Math.abs(diff);
  if (abs < 60) return rtf.format(Math.round(diff), 'second');
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
  if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), 'day');
  return formatDate(d);
}

export function slugify(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 64);
}

export function parseNumber(value: string): number | undefined {
  if (value.trim() === '') return undefined;
  const n = Number(value.replace(',', '.'));
  return Number.isFinite(n) ? n : undefined;
}

export function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'object' && err && 'message' in err) return String((err as { message: unknown }).message);
  return 'Something went wrong';
}

export const LEVEL_LABELS: Record<string, string> = {
  emr: 'EMR',
  emt: 'EMT',
  aemt: 'AEMT',
  paramedic: 'Paramedic',
  critical_care: 'Critical Care',
  nurse: 'Nurse',
  physician: 'Physician',
};

export const ROLE_LABELS: Record<string, string> = {
  provider: 'Provider',
  educator: 'Educator',
  medical_director: 'Medical Director',
  admin: 'Administrator',
  owner: 'Owner',
};

export const ORG_TYPE_LABELS: Record<string, string> = {
  ems_agency: 'EMS agency',
  hospital: 'Hospital',
  medical_direction: 'Medical direction',
  regional_system: 'Regional EMS system',
  education: 'Education program',
  other: 'Other',
};
